// ThirdParty
import { combineReducers } from 'redux';

// project import
import auth from './auth';
import rolesAndPermissions from './dashboard/rolesAndPermissions';
import users from './dashboard/usersReducer';
import groups from './dashboard/groupsReducer';
import levelOfServices from './dashboard/levelOfServiceReducer';
import vehicleTypes from './dashboard/vehicleTypesReducer';
import vehicles from './dashboard/vehiclesReducer';
import lists from './dashboard/listsReducer';
import patients from './dashboard/patientsReducer';
import drivers from './dashboard/driversReducer';
import billingItems from './admin/billingItemsReducer';
import payors from './admin/payorReducer';
import payorItems from './admin/payorSourceItemsReducer';
import dynamicForm from './admin/dynamicForm';
import trips from './dashboard/tripsReducer';
import dashboardFilters from './dashboard/dashboardFiltersReducer';
import facilities from './admin/facilityReducer';
import providers from './admin/providerReducer';
import zones from './admin/zonesReducer';
import connections from './admin/connectionReducer';
import activityLogs from './admin/activityLogs';
import company from './admin/companyReducer';
import invoices from './admin/invoicesReducer';
import payments from './admin/paymentsReducer';
import emailNotification from './admin/emailNotificationReducer';
import openApi from './admin/openAPiReducer';
import notifications from './notificationsReducer';

// ==============================|| COMBINE REDUCERS ||============================== //

const rootReducer = combineReducers({
  rolesAndPermissions,
  auth,
  groups,
  users,
  levelOfServices,
  vehicleTypes,
  vehicles,
  lists,
  patients,
  drivers,
  billingItems,
  payors,
  payorItems,
  dynamicForm,
  trips,
  dashboardFilters,
  facilities,
  providers,
  zones,
  connections,
  activityLogs,
  company,
  invoices,
  payments,
  emailNotification,
  openApi,
  notifications
});
const reducers = (state, action) => {
  if (action.type === 'LOGOUT') {
    state = undefined;
  }

  return rootReducer(state, action);
};

export default reducers;
